// removed by extract-text-webpack-plugin
module.exports = {"complexRacer":"_21qqVYUM7Pu9LYQMI4gfnx","button":"_3xPcPm9mCG1sjFfHeGVZrw","selected":"_1NJhUZ7XVA8lcy6FtlcWqn"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/complexRacer.css
// module id = 995
// module chunks = 0